var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10003_1057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7959 29.7164L25.2691 26.4798C30.9239 23.6524 33.7513 22.2387 33.7513 20C33.7513 17.7612 30.9239 16.3475 25.2691 13.5201L18.7959 10.2836C14.232 8.00157 11.95 6.86057 10.627 7.21081C9.36846 7.544 8.38552 8.52694 8.05233 9.78548C7.70209 11.1084 8.84309 13.3904 11.1251 17.9544C11.4915 18.6872 11.6747 19.0537 11.7506 19.4371C11.8242 19.8088 11.8242 20.1912 11.7506 20.5628C11.6747 20.9463 11.4915 21.3127 11.1251 22.0455C8.84309 26.6095 7.70209 28.8915 8.05233 30.2145C8.38551 31.473 9.36846 32.456 10.627 32.7891C11.95 33.1394 14.232 31.9984 18.7959 29.7164Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9162 19.9993L19.0205 19.9556",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10003_1057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d4b92075986204db7b8cc1e40146eed0.svg";
export { ForwardRef as ReactComponent };